import React from "react";

import FullLogoPrimary from "@/assets/logos/full-logo-secondary.png";
import MDBox from "@/components/atoms/MDBox";
import MDTypography from "@/components/atoms/MDTypography";
import ISalesProductPrice from "@/interfaces/sales-product-price.interfaces";
import ISalesProduct from "@/interfaces/sales-product.interfaces";

type ProductImageProps = {
  salesProduct: ISalesProduct;
  salesProductPrice: ISalesProductPrice;
};

const getProductImage = (productImage: string | undefined): string => {
  return productImage ? `data:image/jpeg;base64,${productImage}` : FullLogoPrimary;
};

export default function ProductImage({ salesProduct, salesProductPrice }: ProductImageProps) {
  const imageWidth = 180;
  const imageHeight = 180;

  const { productImage, name } = salesProduct;
  const { planName } = salesProductPrice;

  const imageSrc = getProductImage(productImage);

  return (
    <MDBox sx={{ width: "100%" }}>
      <MDBox p={3} width="100%">
        <MDBox mt={1} width="100%" display={"flex"} justifyContent={"center"} borderRadius="lg">
          <img
            width={imageWidth}
            height={imageHeight}
            src={imageSrc}
            alt={name}
            style={{ borderRadius: "50%" }}
          />
        </MDBox>

        <MDBox mt={2} display={"flex"} justifyContent={"center"}>
          <MDTypography textAlign={"center"} variant="h5" fontWeight={"bold"}>
            {name}
            <MDTypography variant="h5" fontWeight={"bold"}>
              {planName}
            </MDTypography>
          </MDTypography>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}
